<script>
export const LACOSTE_BOTTOM_NAV_ROUTES = [
  "/profile",
  "/purchase-history",
  "/privilege"
];

const PROFILE_ICON = require("@/assets/images/lacoste/Home.png");
const TRANSACTION_ICON = require("@/assets/images/global/transaction.svg");
const PRIVILEGE_ICON = require("@/assets/images/lacoste/Exclusif.png");

export default {
  name: "LacosteBottomNavigation",
  computed: {
    tabs() {
      return [
        {
          key: "profile",
          label: this.$t("profile"),
          route: LACOSTE_BOTTOM_NAV_ROUTES[0],
          icon: PROFILE_ICON
        },
        {
          key: "transaction",
          label: this.$t("transaction_header"),
          route: LACOSTE_BOTTOM_NAV_ROUTES[1],
          icon: TRANSACTION_ICON
        },
        {
          key: "privilege",
          label: this.$t("privilege"),
          route: LACOSTE_BOTTOM_NAV_ROUTES[2],
          icon: PRIVILEGE_ICON
        }
      ];
    }
  },
  methods: {
    isActive(route) {
      if (route === "/profile") return this.$route.path === route;
      return (
        this.$route.path === route ||
        this.$route.path.startsWith(`${route}/`)
      );
    },
    goTo(route) {
      if (!this.isActive(route)) this.$router.push(route);
    }
  }
};
</script>

<template>
  <nav data-lang="profile"
    class="lacoste-bottom-nav"
    data-test="lacoste-bottom-nav"
    :aria-label="$t('profile')"
  >
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      :class="[
        'lacoste-bottom-nav__item',
        { 'is-active': isActive(tab.route) }
      ]"
      :data-test="`lacoste-nav-tab-${tab.key}`"
      :aria-current="isActive(tab.route) ? 'page' : undefined"
      @click="goTo(tab.route)"
    >
      <img
        :src="tab.icon"
        @error="e => (e.target.src = handleImageSrc)"
        class="lacoste-bottom-nav__icon"
        :alt="tab.label"
      />
      <span class="lacoste-bottom-nav__label f-body">{{ tab.label }}</span>
    </button>
  </nav>
</template>

<style lang="scss" scoped>
.lacoste-bottom-nav {
  --lacoste-nav-radius: 20px;

  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  min-height: calc(72px + env(safe-area-inset-bottom));
  // padding: 8px 0 calc(8px + env(safe-area-inset-bottom));
  background: #fff;
  // border-top-left-radius: var(--lacoste-nav-radius);
  // border-top-right-radius: var(--lacoste-nav-radius);
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.08);
}

.lacoste-bottom-nav__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 4px;
  border: 0;
  background: transparent;
  color: var(--text-color, #333);
  opacity: 0.75;
  cursor: pointer;
  transition: opacity 0.2s ease, background 0.2s ease;
}

.lacoste-bottom-nav__item.is-active {
  background: var(--primary-color);
  color: var(--font-primary-color, #fff);
  opacity: 1;
}

.lacoste-bottom-nav__icon {
  width: 44px;
  height: 36px;
  object-fit: contain;
}

.lacoste-bottom-nav__label {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
